import { pageType } from '@/types/securityServer';
import { PAGE_TYPE } from '@/const/configuration';
import { GODO_SECURE_LIST, SECURITY_SERVER } from '@/const/url';
import { throwExternalWindowPopup } from '@/helpers/popup';

export const goToExternal = (page: pageType, sno?: string) => {
  const url = `${page === PAGE_TYPE.DOMAIN ? SECURITY_SERVER : GODO_SECURE_LIST}?sno=${sno}`;
  throwExternalWindowPopup(url, 'new', null);
};
